module.exports = "<app-widgets-label help-text=$ctrl.i18nHelp> <custom-label> <label> <input type=checkbox ng-model=$ctrl.field ng-disabled=$ctrl.disabled ng-change=$ctrl.change()> <span></span> {{ ::$ctrl.label }} </label> </custom-label> </app-widgets-label> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/checkbox/partial.html
// module id = 534
// module chunks = 0